import { render, staticRenderFns } from "./QuoteAnnexForm.vue?vue&type=template&id=27ff046a&scoped=true&"
import script from "./QuoteAnnexForm.vue?vue&type=script&lang=js&"
export * from "./QuoteAnnexForm.vue?vue&type=script&lang=js&"
import style0 from "./QuoteAnnexForm.vue?vue&type=style&index=0&id=27ff046a&prod&scoped=true&lang=css&"
import style1 from "./QuoteAnnexForm.vue?vue&type=style&index=1&id=27ff046a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff046a",
  null
  
)

export default component.exports